import { createContext, useContext, useEffect, useState } from "react";
import { DICT, LANGUAGES } from "./translations";

const SUPPORTED = new Set(LANGUAGES.map((x) => x.code));
const LangCtx = createContext({
  lang: "en",
  setLang: () => {},
  t: (k) => k,
  languages: LANGUAGES,
});

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "en";
    const saved = window.localStorage.getItem("ap_lang");
    return SUPPORTED.has(saved) ? saved : "en";
  });

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.localStorage.setItem("ap_lang", lang);
      document.documentElement.setAttribute("lang", lang);
    }
  }, [lang]);

  const setLang = (code) => setLangState(SUPPORTED.has(code) ? code : "en");
  const t = (key) => {
    const bucket = DICT[lang] || DICT.en;
    return bucket[key] ?? DICT.en[key] ?? key;
  };

  return (
    <LangCtx.Provider value={{ lang, setLang, t, languages: LANGUAGES }}>
      {children}
    </LangCtx.Provider>
  );
}

export function useLang() {
  return useContext(LangCtx);
}
